import { QuestionType } from '@/domain/impact/impact.entity';
import {
  EssQuestions,
  EssQuestionValue,
} from '@/domain/impact-ess/entities/question.entity';
import {
  EssSection,
  EssTopic,
} from '@/domain/impact-ess/entities/question.entity';
import { ImpactEssGateway } from '@/domain/impact-ess/gateways/impact-ess.gateway';

export class ApiImpactEssFakeGateway implements ImpactEssGateway {
  answers: EssQuestions = FAKE_INITIAL_ESS_QUESTIONS;
  responses: EssQuestionValue[] = FAKE_INITIAL_ESS_RESPONSES;

  async getImpactEssQuestions(): Promise<EssQuestions> {
    await new Promise((r) => setTimeout(r, 500));

    // 👨‍💻 dev - normal case
    return this.answers;

    // 👨‍💻 dev - throw-error
    // throw 'error in api';
  }

  async getImpactEssResponses(): Promise<EssQuestionValue[]> {
    await new Promise((r) => setTimeout(r, 500));

    // 👨‍💻 dev - normal case
    return this.responses;

    // 👨‍💻 dev - throw-error
    // throw 'error in api';
  }

  async createImpactEssResponse(
    projectId: number,
    paramId: string,
    value: string,
  ): Promise<void> {
    await new Promise((r) => setTimeout(r, 500));

    // 👨‍💻 dev - normal case
    const response: EssQuestionValue = {
      paramId,
      value,
      id: this.getNewIdAnswer(),
    };
    this.responses = [...this.responses, response];

    // 👨‍💻 dev - throw-error
    // throw 'error in api';
  }

  getNewIdAnswer(): number {
    return this.responses.reduce((prev, cur) => Math.max(cur.id, prev), 0) + 1;
  }
  async editImpactEssResponse(answerId: number, value: string): Promise<void> {
    await new Promise((r) => setTimeout(r, 500));

    // 👨‍💻 dev - normal case
    const index = this.responses.findIndex((x) => x.id === answerId);
    this.responses = [...this.responses];
    this.responses[index] = { ...this.responses[index], value: value };

    // 👨‍💻 dev - throw-error
    // throw 'error in api';
  }
}

const FAKE_INITIAL_ESS_QUESTIONS: EssQuestions = {
  ESS_1: {
    paramId: 'ESS_1',
    topic: EssTopic.PARITY_EQUALITY,
    section: EssSection.ARTISTIC_TEAM,
    type: QuestionType.NUMERIC,
    title: {
      fr: 'Nombre de projets artistiques',
      en: 'Number of artistic projects',
    },
  },
  ESS_2: {
    paramId: 'ESS_2',
    topic: EssTopic.PARITY_EQUALITY,
    section: EssSection.ARTISTIC_TEAM,
    type: QuestionType.NUMERIC,
    title: {
      fr: "Nombre de personnes performant sur l'événement",
      en: 'Number of people performing at the event',
    },
  },
  ESS_3: {
    paramId: 'ESS_3',
    topic: EssTopic.PARITY_EQUALITY,
    section: EssSection.ARTISTIC_TEAM,
    type: QuestionType.PERCENT_SLIDER,
    title: {
      fr: 'Parité  équipe artistique (0 plutôt lead masculin, 50% lead mixte, 100% lead féminin)',
      en: 'Gender parity in artistic team (0 mostly male lead, 50% mixed lead, 100% female lead)',
    },
  },
  ESS_3ALT: {
    paramId: 'ESS_3ALT',
    topic: EssTopic.PARITY_EQUALITY,
    section: EssSection.ARTISTIC_TEAM,
    type: QuestionType.FACTOR,
    title: {
      fr: "Parité  équipe artistique (inscrivez le nombre de femmes et d'hommes dans votre programmation)",
      en: 'Gender parity in artistic team (indicate the number of women and men in your programming)',
    },
    fields: [
      {
        title: {
          fr: 'Nombre des femmes',
          en: 'Number of women',
        },
      },
      {
        title: {
          fr: "Nombre d'hommes'",
          en: 'Number of men',
        },
      },
    ],
  },
  ESS_5: {
    paramId: 'ESS_5',
    topic: EssTopic.PARITY_EQUALITY,
    section: EssSection.PERMANENT_OPERATIONAL_TEAM,
    type: QuestionType.SELECT,
    title: {
      fr: 'Types de contrats pratiqués',
      en: 'Types of contracts concluded',
    },
    options: [
      {
        optionId: 'direct',
        title: {
          fr: "Direct (contrat d'engagement)",
          en: 'Direct (contract of employment)',
        },
      },
      {
        optionId: 'assignment',
        title: {
          fr: 'Contrat de cession - co production - coréalisation',
          en: 'Assignment contract - co-production - co-direction',
        },
      },
    ],
  },
  ESS_26: {
    paramId: 'ESS_26',
    topic: EssTopic.PARITY_EQUALITY,
    section: EssSection.VOLUNTEERS,
    type: QuestionType.BOOLEAN,
    title: {
      fr: 'Est-ce que vous faites appel à des bénévoles ?',
      en: 'Do you rely on volunteers?',
    },
  },
  ESS_30: {
    paramId: 'ESS_30',
    topic: EssTopic.PARITY_EQUALITY,
    section: EssSection.VOLUNTEERS,
    type: QuestionType.SELECT,
    title: {
      fr: "Cadre d'accueil des bénévoles",
      en: 'Do you rely on volunteers?',
    },
    options: [
      {
        optionId: 'meals',
        title: {
          fr: 'Repas',
          en: 'Meals',
        },
      },
      {
        optionId: 'concerts',
        title: {
          fr: 'Concerts',
          en: 'Concerts',
        },
      },
      {
        optionId: 'accommodation',
        title: {
          fr: 'Hebergement',
          en: 'Accommodation',
        },
      },
      {
        optionId: '2outof3',
        title: {
          fr: '2 des 3',
          en: '2 out of 3',
        },
      },
      {
        optionId: 'all3',
        title: {
          fr: 'Les 3',
          en: 'All 3',
        },
      },
    ],
  },
  ESS_9: {
    paramId: 'ESS_9',
    topic: EssTopic.PARITY_EQUALITY,
    section: EssSection.OCCASIONAL_OPERATIONAL_TEAM,
    type: QuestionType.FACTOR_PERCENTAGE,
    title: {
      fr: 'Parité  équipe ponctuelle',
    },
    fields: [
      {
        title: {
          fr: 'Nombre de contrat F',
        },
      },
      {
        title: {
          fr: 'Nombre de contrats H',
        },
      },
    ],
  },
  ESS_11: {
    paramId: 'ESS_11',
    topic: EssTopic.PARITY_EQUALITY,
    section: EssSection.OCCASIONAL_OPERATIONAL_TEAM,
    type: QuestionType.FACTOR_MINISTRY,
    title: {
      fr: 'Ecart global de rémunération',
    },
    fields: [
      {
        title: {
          fr: 'Prix du plus haut salaire F',
        },
      },
      {
        title: {
          fr: 'Prixdu plus haut salaire M ',
        },
      },
    ],
  },
};

const FAKE_INITIAL_ESS_RESPONSES: EssQuestionValue[] = [
  { id: 0, paramId: 'ESS_1', value: '45' },
];
